import styled from 'styled-components';
import {
  brandBlack,
  whiteSphera,
  greenSp,
  brandYellowgreen,
  grayMediumSphera,
  blackSphera
} from 'src/utilities/UIStyles/variables/Colors';

export const DashboardHomeContainer = styled.section``;

export const DashboardHomeMain = styled.div`
  display: flex;
  margin-top: 3%;

  @media (min-width: 600px) and (max-width: 1024px) {
    padding: 2% 5%;
  }

  @media (max-width: 600px) {
    padding: 2% 5%;
  }
`;

export const DashboardHomeInvestmentOpportunity = styled.div`
  padding: 2.5%;
  background-color: rgb(248, 248, 249);

  > div {
    > h2 {
      font-size: 2.5vw;
      color: ${greenSp};
    }
    > p {
      font-size: 1.2vw;
      color: ${brandBlack};
      margin-bottom: 2.5%;
      width: 100%;
      text-align: center;
    }
    > a {
      display: block;
      color: ${whiteSphera};
      font-weight: bold;
      font-size: 1.2vw;
      text-decoration: none;
      text-align: center;
      line-height: 40px;
      width: 25%;
      height: 40px;
      border: none;
      border-radius: 5px;
      background-color: ${brandBlack};
      cursor: pointer;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    padding: 5% 0 5% 5%;
    > div {
      > h2 {
        font-size: 3.5vw;
        color: ${greenSp};
      }
      > p {
        font-size: 2.2vw;
      }
      > a {
        width: 35%;
        font-size: 2.2vw;
        height: 20px;
        line-height: 20px;
      }
    }
  }
`;

export const Welcome = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50%;
    > h2 {
      color: ${greenSp};
      font-size: 2.5vw;
      font-weight: bold;
      width: 80%;
      margin-right: 10%;
    }
    > h3 {
      color: ${brandBlack};
      font-size: 2.5vw;
      font-weight: bold;
      width: 80%;
      margin-right: 10%;
    }
  }
  > h4 {
    color: ${brandBlack};
    font-size: 2vw;
    font-weight: bold;
    width: 50%;
    padding: 0 2%;
  }
  > p {
    color: ${brandBlack};
    font-size: 1.2vw;
    width: 80%;
    margin: 2% 10%;
    background-color: ${brandYellowgreen};
    padding: 2% 1%;
    > a {
      color: ${grayMediumSphera};
      font-weight: bold;
      border-bottom: 1px solid;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    > div {
      > h2 {
        font-size: 3vw;
      }
      > h3 {
        font-size: 3vw;
      }
    }
    > h4 {
      font-size: 2.5vw;
    }
  }
`;

export const Campaigns = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 2% 5%;
  padding: 2%;
  justify-content: center;
  align-items: center;
  > div {
    width: 100%;
    background-color: ${brandYellowgreen};
    padding: 3% 1%;
    display: flex;
    flex-wrap: wrap;
    > h3 {
      color: ${brandBlack};
      font-size: 2.2vw;
      width: 100%;
      text-align: center;
      margin-bottom: 2%;
      > a {
        text-align: center;
        color: ${blackSphera};
        font-weight: bold;
        padding: 0;
        border-bottom: 1px solid ${brandBlack};
        width: 30%;
        font-size: 1.5vw;
      }
    }
    > h4 {
      color: ${brandBlack};
      font-size: 1.3vw;
      width: 100%;
      text-align: center;
      margin-bottom: 2%;
      font-weight: lighter;
      > a {
        text-align: center;
        color: ${blackSphera};
        font-weight: bold;
        font-size: 1.3vw;
        padding: 0;
        border-bottom: 1px solid ${brandBlack};
        width: 30%;
      }
    }
    > p {
      text-align: center;
      width: 100%;
      font-size: 1.3vw;
      margin-top: 3%;
    }
    > a {
      text-align: center;
      background-color: ${brandBlack};
      color: ${whiteSphera};
      padding: 1%;
      border-radius: 10px;
      width: 40%;
      margin: 0 30%;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > a {
        width: 30%;
        font-size: 1.8vw;
        border-radius: 5px;
        margin: 0 35%;
      }
      > p {
        width: 100%;
        font-size: 1.8vw;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 5% 0 5% 5%;
    > div {
      > a {
        width: 30%;
        font-size: 2.3vw;
        border-radius: 5px;
        margin: 0 35%;
      }
      > p {
        width: 100%;
        font-size: 2.3vw;
      }
    }
  }
`;
